import script from "./toast-host.vue?vue&type=script&setup=true&lang=js"
export * from "./toast-host.vue?vue&type=script&setup=true&lang=js"

import "./toast-host.vue?vue&type=style&index=0&id=50a50a5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a50a5e"]])

export default __exports__